import { render } from "./TwoColumns.vue?vue&type=template&id=e759a7e8"
const script = {}

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__